<template>
  <info-section-card :fields="fields" :data="data">
    <template v-slot:header>
      <h4 class="blue-text">{{L10n('rfq')}}</h4>
    </template>
  </info-section-card>
</template>

<script>
export default {
  name: 'InfoSectionRFQ',
  components: {
    'info-section-card': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Card.vue')
  },
  props: {
    data: { type: Object }
  },
  data () {
    return {
      fields: [
        { title: this.L10n('rfq-id'), fieldName: 'rfqid', classes: 'info-section__label' },
        { title: this.L10n('rfq-type'), fieldName: 'rfqTypeTitle' },
        { title: this.L10n('employee'), fieldName: 'baxEmployeeName' },
        { title: this.L10n('customer'), fieldName: 'customerName' },
        { title: this.L10n('priority'), fieldName: 'priorityTitle' },
        { title: this.L10n('contact-detail'), fieldName: 'customerCompanyDetailCountry' },
        { title: this.L10n('contact'), fieldName: 'customerContactName' }
      ]
    }
  }
}
</script>
